import { Select } from '@smartgift/frontend-toolkit';
import React, { useEffect, useRef, useState } from 'react';

import { Z_INDEX } from '@hero/constants';

import * as S from './style';

const CustomFilter = ({
  selectRef,
  placeholder = 'Filter',
  onChange = () => {},
  options,
  selectedOption,
  isMulti = true,
  onApply,
  onCancel,
  onInputChange,
  styles,
  ...props
}) => {
  const wrapperRef = useRef(null);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (onInputChange) onInputChange(inputValue);
  }, [inputValue]);

  return (
    <S.CustomSelectWrapper ref={wrapperRef}>
      <Select
        ref={selectRef}
        size="sm"
        menuWidth="300px"
        defaultValue={selectedOption}
        value={selectedOption}
        inputValue={inputValue}
        placeholder={placeholder}
        options={options}
        menuPosition="absolute"
        hideSelectedOptions={false}
        showSelectedOptionInPlaceholder={false}
        onChange={onChange}
        onApply={onApply}
        onCancel={onCancel}
        onInputChange={setInputValue}
        isMulti={isMulti}
        controlShouldRenderValue={false}
        styles={{
          ...styles,
          menuPortal: () => ({
            zIndex: Z_INDEX.customFilter
          })
        }}
        {...props}
      />
      {isMulti && selectedOption?.length > 0 && (
        <S.SelectedCount>{selectedOption?.length}</S.SelectedCount>
      )}
    </S.CustomSelectWrapper>
  );
};

export { CustomFilter };
